var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import generateUniqueId from './generateUniqueId';
export default (function (dom, config) {
    var _a;
    var original = Object.assign({}, config);
    var newconfig = __assign(__assign({}, original), { layout: original.layout.map(function (layout) {
            return __assign(__assign({}, layout), { hooks: __assign({}, ((layout === null || layout === void 0 ? void 0 : layout.hooks) || {})), options: __assign({}, ((layout === null || layout === void 0 ? void 0 : layout.options) || {})), views: __assign({}, ((layout === null || layout === void 0 ? void 0 : layout.views) || {})) });
        }), global: __assign(__assign({}, (original.global || {})), { lang: __assign({}, (((_a = original === null || original === void 0 ? void 0 : original.global) === null || _a === void 0 ? void 0 : _a.lang) || {})) }), _widgetInstanceId: generateUniqueId() });
    // Allowed DOM Overwrites
    var elementProps = dom.dataset;
    if (elementProps['feedNumofcards']) {
        newconfig.layout.forEach(function (layout) {
            if (layout.type === 'feed') {
                layout.options.numOfCards = parseInt(elementProps['feedNumofcards']);
            }
        });
    }
    if (elementProps['location']) {
        newconfig.layout.forEach(function (layout) {
            if (layout.type === 'feed') {
                layout.options.defaultLocation = elementProps['location'];
            }
        });
    }
    var searchAttribute = elementProps['search'];
    if (searchAttribute) {
        // Add search block as first
        var hasSearch_1 = false;
        newconfig.layout.forEach(function (layout) {
            if (layout.type === 'search') {
                hasSearch_1 = true;
                if (searchAttribute.toLowerCase() === "advanced") {
                    layout.options.simplesearch = false;
                }
            }
            if (layout.type === 'feed') {
                layout.options.defaultLocation = elementProps['location'];
            }
        });
        if (!hasSearch_1 && newconfig.layout[0].type !== 'rememberMe') {
            var searchBlock = {
                type: 'search',
                options: {
                    simplesearch: searchAttribute.toLowerCase() !== "advanced",
                },
                hooks: {},
                views: {}, // <-- not functional, ts requires it
            };
            newconfig.layout = __spreadArray([searchBlock], newconfig.layout, true);
        }
    }
    if (elementProps['searchPlaceholder']) {
        newconfig.layout.forEach(function (layout) {
            if (layout.type === 'search') {
                layout.options.placeholder = elementProps['searchPlaceholder'];
            }
        });
    }
    if (elementProps['searchPath']) {
        newconfig.layout.forEach(function (layout) {
            if (layout.type === 'search') {
                layout.options.path = elementProps['searchPath'];
            }
        });
    }
    if (elementProps['loadMore']) { // written as data-load-more but converted to camelCase
        newconfig.layout.forEach(function (layout) {
            if (layout.type === 'feed') {
                layout.options.loadMore = true;
                if (elementProps['loadMore'] === 'auto') {
                    layout.options.loadMoreAutomatic = true;
                }
            }
        });
    }
    if (elementProps['feedDefaultpage']) {
        newconfig.layout.forEach(function (layout) {
            if (layout.type === 'feed') {
                layout.options.defaultPage = parseInt(elementProps['feedDefaultpage']);
            }
        });
    }
    return newconfig;
});
